import { FormArray, FormGroup } from '@angular/forms';
import { IAmenityForm } from '@curbnturf/form-helpers';

export function GeneralAmenityValidator(amenities: FormArray<FormGroup<IAmenityForm>>) {
  let valid = true;
  const invalidItems = {};

  amenities.controls.forEach((amenityForm: FormGroup<IAmenityForm>) => {
    const amenity = amenityForm.value;

    if (amenity.type === 'electricity' || amenity.type === 'water' || amenity.type === 'wifi') {
      if (!amenity.description && !amenity.options) {
        valid = false;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (invalidItems as any)[`${amenity.type}Invalid`] = false;
      }
    }
  });

  if (valid) {
    return null;
  }

  return invalidItems;
}
